import { httpApi } from "./http.api";


export const getTemplateList = (page: any, template_type?: string): Promise<{
  count: number;
  next: string;
  previous: string | undefined;
  results: any[];
}> => {
  const params = new URLSearchParams();
  params.append('page', page.toString());
  
  if (template_type) {
    params.append('template_type', template_type);
  }
  
  return httpApi.get<any[]>(`/users/email-template/?${params.toString()}`).then((data: any) => data.data);
};

export const getTemplate = (templateId: number): Promise<any[]> =>
  httpApi
    .get<any[]>("/users/email-template/" + templateId + "/")
    .then((data: any) => data.data);

export const createTemplate = (templateData: any): Promise<any[]> =>
  httpApi
    .post<any[]>("/users/email-template/", templateData)
    .then((data: any) => data.data);

export const deleteTemplate = (templateId: number): Promise<any[]> =>
  httpApi
    .delete<any[]>("/users/email-template/" + templateId + "/")
    .then((data: any) => data.data);

export const updateTemplate = (
  templateId: number,
  templateData: any
): Promise<any[]> =>
  httpApi
    .put<any[]>("/users/email-template/" + templateId + "/", templateData)
    .then((data: any) => data.data);
